import { Eye, EyeOff } from "lucide-react";

const PasswordField = ({ label, value, onChange, show, onToggle }) => (
  <div>
    <label className="block text-sm font-medium text-secondary-600 mb-1">
      {label}
    </label>
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full p-2.5 border rounded-md pr-10"
        required
      />
      <button
        type="button"
        onClick={() => onToggle(!show)}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-secondary-400 hover:text-secondary-600"
      >
        {show ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  </div>
);

export default PasswordField;